import { createFileRoute } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { GeneralPreferencesForm } from "@/components/profile/preferences/general-preferences-form";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql.ts";

import type { JSX } from "react";

const GeneralPreferencesPageQuery = graphql(/* GraphQL */ `
  query GeneralPreferencesPageQuery {
    usuarios {
      ...GeneralPreferencesFormFragment
    }
  }
`);

const GeneralPreferencesPage = (): JSX.Element => {
  const queryResult = useGraphQL(GeneralPreferencesPageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Preferências Gerais" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {data?.usuarios[0] ? <GeneralPreferencesForm data={data.usuarios} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/service-preferences/edit/general-preferences",
)({
  component: GeneralPreferencesPage,
});
